(function () {
    'use strict';


    angular
        .module('cabinPerformanceComment')
        .service('CabinPerformanceCommentService', CabinPerformanceCommentService);

    function CabinPerformanceCommentService(RemoteService, CabinPerformanceCommentFactory, $sce) {
        var self = this,search,updateReq;

        self.searchCabinPerformanceReport = function (params) {
          search = CabinPerformanceCommentFactory.getCabinPerformanceReportSearchRequest();
          search.fromDate = params.fromDate;
          search.toDate = params.toDate;
          search.crewId = params.crewId;
        };

        self.setUpdateCabinPorformanceCommentData = function (params){
          updateReq = CabinPerformanceCommentFactory.getCabinPerformanceReportUpdateRequest();
          updateReq.cabinFlightRatingId = params.cabinFlightRatingId;
          updateReq.ratingComment = params.ratingComments;
          updateReq.rating = params.rating;
        }

        self.getCabinPerformanceComment = function (successFn, errorFn) {
            RemoteService.getCabinPerformanceCommentReport(search).then(
                function (response) {
                    successFn(response.cabinPerformanceCommentDTOList);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.updateCabinPerformanceComment = function (successFn, errorFn) {
            RemoteService.updateCabinPerformanceComment(updateReq).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.getCabinPerformanceEditPrivilege = function (successFn, errorFn) {
          RemoteService.getCabinPerformanceEditPrivilege().then(
            function (response) {
              successFn(response.privilegeExists);
            },
            function (error) {
              errorFn(error);
            }
          );
        };

        self.setSelectedComment = function (selectedData) {
          var editorData = CabinPerformanceCommentFactory.getCabinPerformanceReportEditorData();
          editorData.checkIn = selectedData.checkIn;
          editorData.checkInDateTime = selectedData.checkInDateTime;
          editorData.blockTime = selectedData.blockTime;
          editorData.rating = parseInt(selectedData.rating);
          editorData.criteriaDescription = selectedData.criteriaDescription;
          editorData.ratingComments = selectedData.ratingComments;
          editorData.ratedBy = selectedData.ratedBy;
          editorData.cabinFlightRatingId = selectedData.cabinFlightRatingId;
          editorData.cabinFlightRatingLogDTOList = selectedData.cabinFlightRatingLogDTOList;
          return editorData;

        }
    }
})();
